import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
import { ImageCdnUrlResolver } from '@/utils/image/image-resolver.utils';
import { LazyLoader } from '@/utils/image/image-lazy-loader.utils';

type VueRuntime = typeof Vue & {
    prototype?: {
        $Lazyload?: object;
    };
};

type VuePlugin = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    install: (targetVue: typeof Vue, options?: Record<string, any>) => void;
};

declare global {
    interface Window {
        ImageCdnUrlResolver?: typeof ImageCdnUrlResolver;
        LazyLoader?: typeof LazyLoader;
    }
}

/**
 * 安裝圖片載入 runtime
 */
export const installImageRuntime = (): void => {
    if (!window.ImageCdnUrlResolver) {
        window.ImageCdnUrlResolver = ImageCdnUrlResolver;
    }

    if (!window.LazyLoader) {
        window.LazyLoader = LazyLoader;
    }

    // 先註冊 vue-lazyload，讓頁面可直接用 v-lazy
    const vueRuntime = Vue as VueRuntime;
    const hasLazyload = !!vueRuntime.prototype?.$Lazyload;

    if (!hasLazyload) {
        vueRuntime.use(VueLazyload as VuePlugin, {
            observer: true,
        });
    }
};
